import { useMemo } from 'react';
import { AssetTypes } from 'src/features/asset-details/types/asset';
import { useGetMultipleLatestReadings } from 'src/hooks/apiHooks/useGetMultipleLatestReadings';
import { usePumpStateAndMode } from 'src/hooks/featureHooks/usePumpStateAndMode';
import { AssetResponse } from 'src/types/assets';

type Props = {
  assetActiveAlarm: number | null;
  liveActiveState?: string;
  asset?: AssetResponse;
};

export const usePumpData = ({ asset, assetActiveAlarm, liveActiveState }: Props) => {
  const pumpAsset = asset?.assetType === AssetTypes.PUMP ? asset : undefined;

  const { activeState, isRunning } = usePumpStateAndMode({ asset: pumpAsset });

  const { readingsMap: multipleReadings, isDataReady: isMultipleDataReady } =
    useGetMultipleLatestReadings({
      items: asset?.assignedAlarmTags,
    });

  const values = Object.values(multipleReadings)?.map((tagData) => {
    const tagId = Object.keys(tagData)[0];
    const values = tagData[tagId]?.values ?? {};
    return Object.values(values)[0];
  });
  const isAlarmActive: boolean =
    assetActiveAlarm !== null ? assetActiveAlarm === 1 : values.some((item) => Number(item) > 0);

  const displayActiveState = liveActiveState ?? activeState;

  const isAlarmReady = useMemo(
    () =>
      isMultipleDataReady &&
      (isAlarmActive !== undefined || isAlarmActive === false || isAlarmActive),
    [isMultipleDataReady, isAlarmActive]
  );

  const isReady = isMultipleDataReady && isAlarmReady;

  const isPumpMappedToAlarmTags = asset?.assignedAlarmTags?.some((tag) => tag.assignedAlarmTagId);

  return { isReady, isPumpMappedToAlarmTags, displayActiveState, isAlarmActive, isRunning };
};
